import { render, staticRenderFns } from "./commonDevelopmentToolsMenu.vue?vue&type=template&id=8b7dd154&scoped=true&"
import script from "./commonDevelopmentToolsMenu.vue?vue&type=script&lang=js&"
export * from "./commonDevelopmentToolsMenu.vue?vue&type=script&lang=js&"
import style0 from "./commonDevelopmentToolsMenu.vue?vue&type=style&index=0&id=8b7dd154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7dd154",
  null
  
)

export default component.exports